var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdOrientation } from "../../constants/IdOrientation";
import { IdStyles } from "../../less/IdStyles";
import { selectAllRecipesForAllStages } from "../../selectors/selectRecipeInfo";
import { utilBuildings } from "../../utils/utilBuildings";
import { utilPager } from "../../utils/utilPager";
import { TypeRecipeCost } from "../balancing/TypeRecipeCost";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { Pager } from "../generic/pager/Pager";
import { RemainingTimeDisplay } from "../generic/remaining-time-display/RemainingTimeDisplay";
import { MenuInfoContentTitleRecipe } from "./MenuInfoContentTitleRecipe";
import { MenuInfoTable } from "./MenuInfoTable";
var MenuInfoContentProduction = /** @class */ (function (_super) {
    __extends(MenuInfoContentProduction, _super);
    function MenuInfoContentProduction(props, context) {
        var _this = _super.call(this, props, context) || this;
        // TODO: Refactor to return proper Header component
        _this.getHeaders = function (buildingStage) {
            var recipesByStages = _this.props.recipesByStages;
            var recipe = recipesByStages[buildingStage.level - 1][_this.state.recipeIdx];
            var lastRecipe = recipesByStages[recipesByStages.length - 1][_this.state.recipeIdx];
            var headers = [];
            var key = 0;
            var modifierIconProps = {
                icon: IdIcon.GreenArrowUpIcn,
                position: IdBadgePosition.Right,
                styleId: IdStyles.IconSmall,
            };
            // Add level
            headers.push(React.createElement("div", { className: "info-menu__table-th", key: key },
                React.createElement("div", { className: "flex flex--guts flex__full" },
                    React.createElement(IconWithModifier, { styleId: IdStyles.IconMedium, icon: IdIcon.FarmNameIcn, modifierIconProps: modifierIconProps }))));
            key++;
            // Add costs
            recipe.cost.filter(_this.shouldShowCost).forEach(function (cost, idx) {
                var costIcon = getResourceIcon(cost);
                headers.push(React.createElement("div", { className: "info-menu__table-th", key: idx + key },
                    React.createElement("div", { className: "flex flex--guts flex__full" },
                        React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: costIcon }))));
            });
            key += recipe.cost.length;
            // Add time
            headers.push(React.createElement("div", { className: "info-menu__table-th", key: key },
                React.createElement("div", { className: "flex flex--guts flex__full" },
                    React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: IdIcon.TimeIcn }))));
            key++;
            // Add products
            lastRecipe.product.forEach(function (product, idx) {
                var resourceIcon = getResourceIcon(product);
                if (_this.shouldShowProduct(product)) {
                    headers.push(React.createElement("div", { className: "info-menu__table-th", key: idx + key },
                        React.createElement("div", { className: "flex flex--guts flex__full" },
                            React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: resourceIcon }))));
                }
            });
            key += recipe.product.length;
            // Add Xp
            headers.push(React.createElement("div", { className: "info-menu__table-th", key: key },
                React.createElement("div", { className: "flex flex--guts flex__full" },
                    React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: IdIcon.XpIcn }))));
            return headers;
        };
        _this.getRows = function (buildingStage) {
            var recipesByStages = _this.props.recipesByStages;
            return recipesByStages.map(function (recipes, idx) {
                var recipe = recipes[_this.state.recipeIdx];
                var fullRecipe = recipesByStages[recipesByStages.length - 1][_this.state.recipeIdx];
                var values = _this.getValues(idx + 1, recipe, fullRecipe);
                var className = buildingStage.level === idx + 1 ? "selected" : "";
                return (React.createElement("div", { key: recipe.recipe.id, className: "info-menu__table-tr " + className + " " + IdStyles.TableRow }, values));
            });
        };
        _this.getValues = function (level, recipe, fullRecipe) {
            var values = [];
            var key = 0;
            // Add level
            values.push(React.createElement("div", { className: "info-menu__table-td", key: key },
                React.createElement(NumberFormat, { amount: level })));
            key++;
            // Add costs
            recipe.cost.filter(_this.shouldShowCost).forEach(function (cost, idx) {
                values.push(React.createElement("div", { className: "info-menu__table-td", key: idx + key },
                    React.createElement(NumberFormat, { amount: cost.amount, format: TypeNumberFormat.Subtract })));
            });
            key += recipe.cost.length;
            // Add time
            var productionTime = recipe.recipe.ignoreProductionTime
                ? 0
                : recipe.recipe.productionTime || 0;
            values.push(React.createElement("div", { className: "info-menu__table-td", key: key },
                React.createElement(RemainingTimeDisplay, { seconds: productionTime })));
            key++;
            // Add products
            fullRecipe.product.forEach(function (potentialProduct, idx) {
                var product = recipe.product.find(function (candidate) { return candidate.id === potentialProduct.id; });
                if (_this.shouldShowProduct(potentialProduct)) {
                    if (product == undefined) {
                        product = __assign({}, potentialProduct, { amount: Long.ZERO });
                    }
                    // TODO: add buffs from library after buffs are implemented
                    values.push(React.createElement("div", { className: "info-menu__table-td", key: idx + key },
                        React.createElement(NumberFormat, { amount: product.amount })));
                }
            });
            key += recipe.product.length;
            // Add Xp
            var xp = recipe.recipe.xp ? recipe.recipe.xp.amount : 0;
            values.push(React.createElement("div", { className: "info-menu__table-td", key: key },
                React.createElement(NumberFormat, { amount: xp })));
            return values;
        };
        // TODO should we remove this??
        _this.shouldShowProduct = function (product) {
            return true;
        };
        _this.shouldShowCost = function (cost) {
            return cost.type !== TypeRecipeCost.Seed || cost.amount.greaterThan(0);
        };
        _this.getPager = function () {
            var recipesByStages = _this.props.recipesByStages;
            var recipes = recipesByStages[0];
            var pageCount = recipes.length;
            return (React.createElement(Pager, { pageCount: pageCount, wrap: true }, _this.renderPager));
        };
        _this.renderPager = function (page, changePage) {
            var recipesByStages = _this.props.recipesByStages;
            var recipes = recipesByStages[0];
            var pageCount = recipes.length;
            return pageCount <= 1 ? (React.createElement(React.Fragment, null)) : (React.createElement(List, { className: "info-menu__header-wrapper", items: utilPager.getPageItemsNext(recipes, page), renderItem: function (recipe, index) {
                    return (React.createElement("div", { key: (recipe.recipe.id || index).toString(), className: "info-menu__header" },
                        React.createElement(ButtonNormalSmall, { onClick: function () { return _this.onRecipeChange(changePage(page - 1)); } },
                            React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconMedium, orientation: IdOrientation.Left })),
                        React.createElement(MenuInfoContentTitleRecipe, __assign({}, recipe)),
                        React.createElement(ButtonNormalSmall, { onClick: function () { return _this.onRecipeChange(changePage(page + 1)); } },
                            React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconMedium, orientation: IdOrientation.Right }))));
                } }));
        };
        _this.onRecipeChange = function (index) {
            _this.setState({
                recipeIdx: index,
            });
        };
        _this.state = {
            recipeIdx: 0,
        };
        return _this;
    }
    MenuInfoContentProduction.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.building !== undefined;
    };
    MenuInfoContentProduction.prototype.render = function () {
        var building = this.props.building;
        var buildingStage = utilBuildings.getBalancingStage(building);
        var pager = this.getPager();
        var headers = this.getHeaders(buildingStage);
        var rows = this.getRows(buildingStage);
        return (React.createElement("div", { className: "info-menu-wrapper" },
            React.createElement("div", { className: "info-menu" },
                pager,
                React.createElement(MenuInfoTable, { headers: headers, rows: rows }))));
    };
    return MenuInfoContentProduction;
}(React.Component));
var mapState = function (state) {
    var building = state.playerBase.buildings.building;
    var recipesByStages;
    if (building != undefined) {
        recipesByStages = selectAllRecipesForAllStages(state, building.balancing.id);
    }
    return {
        building: building,
        recipesByStages: recipesByStages,
    };
};
export var MenuInfoContentProductionDOM = connect(mapState)(MenuInfoContentProduction);



//////////////////
// WEBPACK FOOTER
// ./src/features/info-menu/MenuInfoContentProductionDOM.tsx
// module id = 2841
// module chunks = 3